export enum RouteEnum {
  AdminDashboard = '/admin/dashboard',
  AdminProfiles = '/admin/admin-profiles',
  UniversityProfiles = '/admin/university-profiles',
  StudentProfiles = '/admin/student-profiles',
  AdminNudgeStudents = '/admin/nudgeStudents',
  AdminFundAllocations = '/admin/fundAllocations',
  AdminDeclinedApplications = '/admin/declinedApplications',
  HodDashboardBursaries = '/dashboard',
  HodDashboardApplication = '/dashboard',
  DeanFunds = 'dashboard/funds',
  DeanProfiles = '/dashboard/profiles',
  Reports = '/admin/reports',
  OnboardStudents = '/admin/onboardStudents',
  BulkUploadStudents = '/admin/bulkUploadStudents',
  AdminActiveBursaries = '/admin/activeBursaries',
  AdminApplications = '/admin/applications',
  AdminCreateEvent = '/admin/createEvent',
  AdminEventList = '/admin/events',
  Logout = 'api/logout'
}
